import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';

class Equipments extends EventEmitter {
    OnChange = "";
    PageLoad = "";
    AddToCart = "";
    WorkOrder = "";
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handleEquipments = (action) => {
        switch (action.action.type) {
            case "EqipmentSearchResult": {
                this.OnChange = action.action.response;
                this.emit('EqipmentSearchResult');
                break;
            }
            case "EqipmentPageLoad": {
                this.PageLoad = action.action.response;
                this.emit('EqipmentPageLoad');
                break;
            }
            case "AddToClick": {
                this.AddToCart = action.action.response;
                this.emit('AddToClick');
                break;
            }
            case "EquipmentWorkOrder": {

                this.WorkOrder = action.action.response;
                this.emit('EquipmentWorkOrder');
                break;
            }
            case "workorderfail": {
                this.workorderresponse = "fail";
                this.emit('WOfail');
                break;
            }


        }
    }
}
const objEquipments = new Equipments;
Dispatcher.register(objEquipments.handleEquipments.bind(objEquipments));
export default objEquipments;